import { DiGraph } from "../../graph/digraph.js";

/**
 * Meta / pitch subject: the curriculum *is* the product's benefits, so playing the
 * course is itself the proof that notanyai works for adaptive, measured training.
 * Each node is a benefit; edges are "builds on" so PageRank/topo order the tour.
 */
const EDGES: readonly [string, string][] = [
  ["adaptive_core", "measured_proof"],
  ["adaptive_core", "your_content"],
  ["adaptive_core", "engagement_loop"],
  ["your_content", "self_hosted"],
  ["self_hosted", "privacy_first"],
  ["self_hosted", "open_no_lockin"],
];

export const NOTANY_NODE_IDS: readonly string[] = [
  "adaptive_core",
  "measured_proof",
  "your_content",
  "self_hosted",
  "privacy_first",
  "engagement_loop",
  "open_no_lockin",
];

export function buildNotanyGraph(): DiGraph {
  const g = new DiGraph();
  for (const [a, b] of EDGES) {
    g.addEdge(a, b, 1);
  }
  for (const id of NOTANY_NODE_IDS) {
    g.addNode(id);
  }
  return g;
}
